export default "__VITE_ASSET__CtyNer13__"